import type { Operator, UAS, User } from '@/shared/types';

export interface BackendOperator {
  id: number;
  name: string;
  registration_number: string;
}

export interface BackendUASTypeDetail {
  id: number;
  name: string;
  manufacturer: string;
  mtom_kg: string | null;
  vlos_max_distance_m: number | null;
}

export interface BackendUASDevice {
  id: number;
  serial_number: string;
  uas_type: number;
  uas_type_detail: BackendUASTypeDetail | null;
  operator: number;
}

export interface BackendUserProfile {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  phone: string;
  operators: BackendOperator[];
  caa_cert_number: string;
}

export function mapUser(profile: BackendUserProfile, devices: BackendUASDevice[]): User {
  const operators: Operator[] = profile.operators.map(op => ({
    id: String(op.id),
    name: op.name,
    address: '',
    registrationNumber: op.registration_number,
  }));

  const uasList: UAS[] = devices.map(d => ({
    id: String(d.id),
    type: d.uas_type_detail?.name ?? String(d.uas_type),
    serialNumber: d.serial_number,
    mtomKg: d.uas_type_detail?.mtom_kg != null ? Number(d.uas_type_detail.mtom_kg) : undefined,
    vlosMaxDistanceM: d.uas_type_detail?.vlos_max_distance_m ?? undefined,
  }));

  return {
    id: String(profile.id),
    name: `${profile.first_name} ${profile.last_name}`.trim(),
    email: profile.email,
    phone: profile.phone,
    certificateNumber: profile.caa_cert_number,
    operators,
    uasList,
  };
}
